export default function (store, { currentValue, dropdown, targetDate, }) {
    const { stateEditableItem } = store.getState();
    store.setState({
        stateEditableItem: {
            ...stateEditableItem,
            currentValue,
            dropdown,
            targetDate,
        },
    });
}
//# sourceMappingURL=editing.js.map